import React, { useEffect, useState } from 'react';
import { Modal, Table, Tag, Typography, Button } from 'antd';
import { GetJutgeActivitatsIdAlumnes } from '../../../../dao/jutge/GetJutgeActivitatsIdAlumnes';
import JutgeColors from '../../../../styles/JutgeColors';

const { Text } = Typography;

interface Props {
    visible: boolean;
    onClose: () => void;
    activitat: any;
}

const ActivitatAlumnesModal = ({ visible, onClose, activitat }: Props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        if (visible && activitat) {
            getData();
        }
    }, [visible, activitat]);

    async function getData() {
        setLoading(true);
        const res = await GetJutgeActivitatsIdAlumnes(activitat.id);
        if (res && Array.isArray(res)) {
            // Sort by name
            res.sort((a: any, b: any) => a.usuari.localeCompare(b.usuari));
            setData(res);
        }
        setLoading(false);
    }

    const columns = [
        {
            title: 'Alumne',
            dataIndex: 'usuari',
            key: 'usuari',
            render: (text: string) => <Text strong>{text}</Text>,
        },
        {
            title: 'Progrés',
            dataIndex: 'progres',
            key: 'progres',
            align: 'center' as const,
            render: (val: number) => {
                const color = val === 100 ? 'green' : val >= 50 ? 'orange' : 'red';
                return <Tag color={color}>{val}%</Tag>;
            }
        },
        {
            title: 'Exercicis',
            key: 'stats',
            align: 'center' as const,
            render: (_: any, record: any) => (
                <span>
                    <Tag color={JutgeColors.colors.color5}>Correctes: {record.be}</Tag>
                    <Tag color={JutgeColors.colors.color1}>Incorrectes: {record.malament}</Tag>
                </span>
            )
        }
    ];

    return (
        <Modal
            title={`Progrés de: ${activitat?.nom}`}
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>
                    Tancar
                </Button>
            ]}
            width={800}
            centered
        >
            <Table
                dataSource={data}
                columns={columns}
                rowKey="id_usuari"
                loading={loading}
                pagination={{ pageSize: 8 }}
                size="small"
            />
        </Modal>
    );
};

export default ActivitatAlumnesModal;
